/**
 * Copyright (c) 2022 ESS-Ehrhardt Software Solutions & Service GmbH
 * Basselscheider Str. 55
 * D-56281 Emmelshausen
 * +49 (0) 67 42 / 87 27 0
 * info@epg.com
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService, Logger, LogService } from '@epg/angular-base-lib';
import {
  HttpClient as TenantHttpClient,
  PublicTenantManagerClient
} from '@epg/tenant-manager-client';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantManagerClientService {
  client!: PublicTenantManagerClient;
  private log: Logger;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private logService: LogService
  ) {
    this.log = this.logService.getLogger(this);
    let TenantManagerEndpoint = '';
    try {
      TenantManagerEndpoint = this.appConfig.getParameter('TenantManagerEndpoint') as string;
      if (!TenantManagerEndpoint.endsWith('/')) {
        TenantManagerEndpoint = TenantManagerEndpoint.concat('/');
      }
      this.client = new PublicTenantManagerClient(
        TenantManagerEndpoint,
        new NgTenantHttpClient(this.http)
      );
    } catch {
      this.log.debug('No API Endpoint defined!');
      TenantManagerEndpoint = '';
    }
  }
}
class NgTenantHttpClient implements TenantHttpClient {
  constructor(private readonly http: HttpClient) {}

  async delete<ResT>(url: string): Promise<ResT> {
    const data$ = this.http.delete<ResT>(url);
    return await lastValueFrom(data$);
  }

  async get<ResT>(url: string): Promise<ResT> {
    const data$ = this.http.get<ResT>(url);
    return await lastValueFrom(data$);
  }

  async patch<ResT, ReqT>(url: string, data?: ReqT | undefined): Promise<ResT> {
    const data$ = this.http.patch<ResT>(url, data);
    return await lastValueFrom(data$);
  }

  async post<ResT, ReqT>(url: string, data?: ReqT | undefined): Promise<ResT> {
    const data$ = this.http.post<ResT>(url, data);
    return await lastValueFrom(data$);
  }

  async put<ResT, ReqT>(url: string, data?: ReqT | undefined): Promise<ResT> {
    const data$ = this.http.put<ResT>(url, data);
    return await lastValueFrom(data$);
  }
}
